//! Please check Figma

enum GREY_COLOR {
  DARK_GREY = "#242526", // Normal text
  BATTLESHIP_GREY = "#797C80", // Secondary Action
  COOL_GREY = "#9DA0A6", // Icon
  COOL_GREY_LIGHT = "#B6BABF", // Placeholder Text
  WHITE_3 = "#D8D8D8", // Selected Background
  WHITE_2 = "#DDDDDD", // Inactive, Border
  WHITE_1 = "#FAFAFA", // Background
  WHITE = "#FFFFFF", // Well, pure white :-)
}

enum SPECIAL_COLOR {
  NAVY_BLUE = "#305E97",
  NAVY_BLUE_PALE = "#4C6B98",
  NAVY_BLUE_DARK = "#274C7B",
  NAVY_BLUE_DARK_BORDER = "#244671",
  ACTIVE = "#2988CC",
  SELECTED = "#EAF3FF",
  SELECTED_PALE = "#E6EAF2",
  DANGER = "#F7554E",
  WARNING = "#FBC938", //=> BUTTER_SCOTCH
  VALID = "#A9C44F", //=> OLIVE_GREEN
}

const COLOR = {
  OLIVE_GREEN: {
    NORMAL: "#A9C44F",
  },
  LIPSTICK: {
    NORMAL: "#B3215D",
  },
  DARKISH_PINK: {
    NORMAL: "#E54658",
    LIGHT: "#EF909B",
    PALE: "#F4CFD3",
    BORDER: "#D53E4F",
    LABEL: "#670F1A",
  },
  WINDOWS_BLUE: {
    NORMAL: "#3288BD",
    LIGHT: "#84B8D7",
    PALE: "#CCE1EE",
    BORDER: "#3288BD",
    LABEL: "#123144",
  },
};

export { COLOR, GREY_COLOR, SPECIAL_COLOR };
